import { render, staticRenderFns } from "./RenewalInplayMobileDetail.vue?vue&type=template&id=13b95f8e&scoped=true"
import script from "./RenewalInplayMobileDetail.vue?vue&type=script&lang=js"
export * from "./RenewalInplayMobileDetail.vue?vue&type=script&lang=js"
import style0 from "./RenewalInplayMobileDetail.vue?vue&type=style&index=0&id=13b95f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b95f8e",
  null
  
)

export default component.exports